const validate = values => {
  const errors = {};
  if (!values.publicText) {
    errors.publicText = 'Campo Obrigatório';
  }
  if (!values.comentario) {
    errors.comentario = 'Campo Obrigatório';
  }

  return errors;
};

export default validate;






// WEBPACK FOOTER //
// ./src/service/validate_nave.js